<template>
	<div class="w-100">
		<el-select remote-show-suffix filterable reserve-keyword clearable multiple :multiple-limit="1"
			:style="{'width': `${width}`}" :disabled="disabled" :size="size" v-model="UserIds" :loading="loading" remote
			@focus="SelectFocus" :placeholder="placeholder" @change="WarehouseChange" @clear="WarehouseClear">
			<el-option v-for="v in OperatorList" :key="v[ValueKey]" :label="v[LabelKey]" :value="v[ValueKey]" />
		</el-select>
	</div>
</template>

<script lang="ts" setup>
	import { ref, getCurrentInstance, defineEmits, defineProps, withDefaults, onMounted, watch } from 'vue';

	interface main {
		id ?: any,
		size ?: string,
		placeholder ?: string,
		ValueKey ?: string,
		LabelKey ?: string,
		width ?: string | number,
		disabled ?: boolean,
		IsAuto ?: boolean,
		WarehouseId ?: string | number,
	};

	const props = withDefaults(defineProps<main>(), {
		id: [],
		size: "default",
		placeholder: "请选择操作员",
		ValueKey: "value",
		LabelKey: "label",
		width: "",
		disabled: false,
		IsAuto: false,
		WarehouseId: "",
	});

	const { proxy } = getCurrentInstance() as any;
	const emits = defineEmits(["update:id", "change", "clear"]);
	const UserIds = ref<any>("");
	const OperatorList = ref<any>([]);
	const loading = ref(false);

	watch(() => props.id, (n : any) => {
		UserIds.value = n;
	});

	onMounted(() => {
		UserIds.value = props.id;
		if (props.IsAuto) {
			if (proxy.$store.state.IsRefreshOperatorList) {
				GetData();
			} else {
				if (proxy.$store.state.OperatorListInfo) {
					if (props.WarehouseId == proxy.$store.state.OperatorListInfo.wid) {
						OperatorList.value = proxy.$store.state.OperatorListInfo.list;
					} else {
						GetData();
					}
				} else {
					GetData();
				}
			}
		}
	});

	const WarehouseChange = (data : any) => {
		emits("update:id", data);
		emits("change", data);
	};
	const WarehouseClear = () => {
		emits("clear");
	};
	const SelectFocus = () => {
		if (proxy.$store.state.IsRefreshOperatorList) {
			GetData();
		} else {
			console.log(proxy.$store.state.OperatorListInfo)
			if (proxy.$store.state.OperatorListInfo) {
				if (props.WarehouseId == proxy.$store.state.OperatorListInfo.wid) {
					OperatorList.value = proxy.$store.state.OperatorListInfo.list;
				} else {
					GetData();
				}
			} else {
				GetData();
			}
		}
	};
	const GetData = () => {
		proxy.$api.tokenRequest({
			url: '/admin/admin',
			data: {
				nickname: "",
				phone: "",
				email: "",
				warehouse_id: props.WarehouseId,
				auth_id: 1,
				rfid: "",
				is_page: 0,
			},
			success: (res : any) => {
				OperatorList.value = res.data;
				proxy.$store.commit("GetAllList", {
					type: 27,
					wid: props.WarehouseId,
					list: res.data,
				});
			},
		});
	}
</script>

<style>
</style>